import firebase from 'firebase';
import { db } from './firebase';
import { FIRESTORE_KEYS } from '../utils/constants';

export default function useSupportTicketService() {
  const createSupportTicket = (data) =>
    db.collection(FIRESTORE_KEYS.SUPPORT_TICKETS).add({
      ...data,
      meta: {
        createdDate: firebase.firestore.FieldValue.serverTimestamp(),
        modifiedDate: firebase.firestore.FieldValue.serverTimestamp(),
      },
    });

  return { createSupportTicket };
}
